import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LandingPage from './LandingPage';

/**
 * Role-based root route component.
 *
 * - Unauthenticated → renders LandingPage
 * - Authenticated but profile not yet loaded → renders null (avoids a
 *   premature role decision during the login transition before the first
 *   Firestore snapshot arrives)
 * - Facility admin with a facilityId → redirects to /facility/:facilityId/dashboard
 * - All other authenticated users → redirects to /cases
 */
export default function HomeIndex() {
    const { user, isFacilityAdmin, facilityId, profileReady } = useAuth();

    if (!user) return <LandingPage />;
    if (!profileReady) return null;
    if (isFacilityAdmin && facilityId) {
        return <Navigate to={`/facility/${facilityId}/dashboard`} replace />;
    }
    return <Navigate to="/cases" replace />;
}
